import styled from "styled-components";
import { v } from "../../styles/variables";

export const LoginMicrosoft = styled.div`
    background: #fff;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    border: 1px solid rgb(181 181 181);
    border-radius: 5px;
    display: flex;
    padding: 1vh;

    svg{
        width: 100%;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 5px;

        path {
            transform-origin: center center;
            transform-box: fill-box;
            transform: translate3d(6vw, 0vw, 0vw);
        }
    }

    [fill*="#8c8c8c"] {
        display: none;
    }
`;

export const LoginMicrosoftBtn = styled.button`
    border: 0px;
    background: transparent;
`